// extracted by mini-css-extract-plugin
module.exports = {"postingJobsContainer":"PostingJobs_postingJobsContainer__1diEQ","jobsBtnContainer":"PostingJobs_jobsBtnContainer__3Ji7n"};